import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'
import store from '@/store'
import Home from '@/views/Home.vue'
import Login from '@/views/UserGroups/Login.vue'
import CreateAccount from '@/views/UserGroups/CreateAccount.vue'
import ForgotPassword from '@/views/UserGroups/ForgotPassword.vue'
import AccountDetails from '@/views/UserGroups/AccountDetails.vue'
import AccountOrders from '@/views/UserGroups/AccountOrders.vue'
import AccountSaved from '@/views/UserGroups/AccountSaved.vue'
import Blog from '@/views/Blog.vue'
import Products from '@/views/Products.vue'
import Product from '@/views/Product.vue'
import ArticleBlog from '@/views/ArticleBlog.vue'
import ArticlePost from '@/views/ArticlePost.vue'
import AboutUs from '@/views/AboutUs.vue'
import Services from '@/views/Services.vue'
import ResetPassword from '@/views/ResetPassword.vue'
import AuthCallback from '@/views/AuthCallback.vue'
import UgmMachines from '@/views/UgmMachines.vue'
import UgmMachine from '@/views/UgmMachine.vue'

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home,
		props: true,
		meta: {
			breadcrumb: 'Home',
			options: ['footer', 'faq', 'discover machines', 'header', 'Meta site'],
		},
	},
	{
		path: '/auth/callback',
		name: 'AuthCallback',
		component: AuthCallback,
	},
	{
		path: '/about-us',
		name: 'AboutUs',
		component: AboutUs,
		props: true,
		meta: {
			breadcrumb: 'About Us',
			options: [
				'footer',
				'faq',
				'header',
				'Learn about our Services',
				'Meta site',
			],
		},
	},
	{
		path: '/services',
		name: 'Services',
		component: Services,
		props: true,
		meta: {
			breadcrumb: 'Services',
			options: ['footer', 'faq', 'discover machines', 'header', 'Meta site'],
		},
	},
	{
		path: '/blogs',
		name: 'blogs',
		component: Blog,
		props: true,
		meta: {
			breadcrumb: 'Blog',
			options: [
				'footer',
				'faq',
				'header',
				'Learn about our Services',
				'Meta site',
			],
		},
		children: [
			{
				path: ':slug',
				name: 'ArticleBlog',
				component: ArticleBlog,
				props: true,
				meta: {
					breadcrumbDynamic: true,
					options: [
						'footer',
						'faq',
						'header',
						'Learn about our Services',
						'Meta site',
					],
				},
			},
		],
	},
	{
		path: '/posts/:slug',
		name: 'ArticlePost',
		component: ArticlePost,
		props: true,
		meta: {
			breadcrumbDynamic: true,
			options: ['footer', 'header', 'Meta site'],
		},
	},
	{
		path: '/products',
		name: 'products',
		component: Products,
		meta: {
			breadcrumb: 'Machines',
			options: ['footer', 'faq', 'header', 'Meta site'],
		},
		children: [
			{
				path: ':slug',
				name: 'product',
				component: Product,
				props: true,
				meta: {
					breadcrumbDynamic: true,
					options: ['footer', 'faq', 'header', 'Meta site'],
				},
			},
		],
	},
	{
		path: '/used-german-machines',
		name: 'ugm-machines',
		component: UgmMachines,
		meta: {
			breadcrumb: 'German Machines',
			options: ['footer', 'faq', 'header', 'Meta site'],
		},
		children: [
			{
				path: ':slug',
				name: 'ugm-machine',
				component: UgmMachine,
				props: true,
				meta: {
					breadcrumbDynamic: true,
					options: ['footer', 'faq', 'header', 'Meta site'],
				},
			},
		],
	},
	{
		path: '/login',
		name: 'login',
		component: Login,
		props: true,
		meta: {
			options: ['header', 'Meta site'],
		},
	},
	{
		path: '/registration',
		name: 'registration',
		component: CreateAccount,
		props: true,
		meta: {
			options: ['header', 'Meta site'],
		},
	},
	{
		path: '/forgot-password',
		name: 'forgot-password',
		component: ForgotPassword,
		props: true,
		meta: {
			options: ['header', 'Meta site'],
		},
	},
	{
		path: '/user/profile',
		name: 'AccountDetails',
		component: AccountDetails,
		props: true,
		meta: { auth: true, role: 'user' },
	},
	{
		path: '/user/orders',
		name: 'AccountOrders',
		component: AccountOrders,
		props: true,
		meta: { auth: true, role: 'user' },
	},
	{
		path: '/user/saved',
		name: 'AccountSaved',
		component: AccountSaved,
		props: true,
		meta: { auth: true, role: 'user' },
	},
	{
		path: '/reset-password/',
		name: 'ResetPassword',
		props: true,
		component: ResetPassword,
		meta: {
			options: ['header', 'Meta site'],
		},
	},
	{
		path: '/maintenance',
		name: 'Maintenance',
		component: () => import('@/views/Maintenance.vue'),
	},
]
const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior(to, from, savedPosition) {
		// Если сохраненная позиция существует (например, при нажатии кнопки "назад"), восстановить её
		if (savedPosition) {
			return savedPosition
		} else {
			// Прокрутить наверх при переходе на новый маршрут
			return { left: 0, top: 0 }
		}
	},
})
router.beforeEach((to, from, next) => {
	if (window.localStorage.getItem('auth_token')) {
		axios.defaults.headers.common['Authorization'] =
			'Bearer ' + window.localStorage.getItem('auth_token')
	}
	if (to.meta.auth) {
		axios
			.post('/account/check/' + to.meta.role)
			.then(res => {
				if (res.data.result == true) {
					const userData = res.data.data
					store.dispatch('setUser', userData)
					next()
				} else {
					window.localStorage.removeItem('auth_token')
					router.push({ name: 'home' })
					return
				}
			})
			.catch(res => {
				if (res.response.status == 401) {
					window.localStorage.removeItem('auth_token')
					router.push({ name: 'home' })
					return
				}
			})
	} else if (window.localStorage.getItem('auth_token')) {
		axios
			.post('/check/auth')
			.then(res => {
				if (res.data.result == true) {
					const userData = res.data.data
					store.dispatch('setUser', userData)
					next()
				} else {
					next()
				}
			})
			.catch(res => {
				if (res.response.status == 401) {
					window.localStorage.removeItem('auth_token')
					router.push({ name: 'home' })
					return
				}
			})
	} else {
		console.log('Пользователь не авторизован.')
		next()
	}
	if (!to.meta.auth) {
		const optionsToLoad = to.meta.options || []
		const pageUrl = to.path // Здесь можно использовать to.params или to.path для динамического URL
		axios
			.get(`/fields`, { params: { url: pageUrl, options: optionsToLoad } })
			.then(response => {
				if (response.data.fields) {
					const fieldData = response.data.fields
					store.dispatch('setFields', fieldData)

					if (fieldData['Meta'] && fieldData['Meta']['Meta title']) {
						updateTitle(fieldData['Meta']['Meta title'])
					} else {
						updateTitle('UBL')
					}

					if (fieldData['Meta'] && fieldData['Meta']['Meta description']) {
						updateMetaDescription(fieldData['Meta']['Meta description'])
					}
				}
				if (response.data.options) {
					const optionsData = response.data.options
					store.dispatch('setOptions', optionsData)

					console.log(optionsData)
					if (optionsData['Meta site']['Icon site']) {
						updateFavicon(optionsData['Meta site']['Icon site'])
					}
				}

				next()
			})
			.catch(error => {
				console.error('Error fetching fields:', error)
				next()
			})
	} else {
		updateTitle('UBL')
		updateMetaDescription('UBL')
	}
})
export default router
function updateTitle(title) {
	let titleTag = document.querySelector('title')
	if (!titleTag) {
		titleTag = document.createElement('title')
		document.head.appendChild(titleTag)
	}
	titleTag.textContent = title || 'UBL'
}

function updateMetaDescription(content) {
	let tag = document.querySelector(`meta[name='description']`)
	if (tag) {
		tag.setAttribute('content', content)
	} else {
		tag = document.createElement('meta')
		tag.setAttribute('name', 'description')
		tag.setAttribute('content', content)
		document.head.appendChild(tag)
	}
}
function updateFavicon(iconUrl) {
	let link = document.querySelector("link[rel='icon']")
	const fullUrl = `${store.state.base_directory}${iconUrl.replace(
		/^public\//,
		''
	)}`
	console.log(fullUrl)
	if (link) {
		link.setAttribute('href', fullUrl)
	} else {
		link = document.createElement('link')
		link.setAttribute('rel', 'icon')
		link.setAttribute('href', fullUrl)
		document.head.appendChild(link)
	}
}
